import './loggly';

const { _LTracker } = window;

export default msg => {
  if (_LTracker) {
    _LTracker.push(msg);
  }
};
